import {
  staffAttendanceList,
  studentAttendanceList,
} from "../../../api/Attendance";
import { AttendanceFollowupList } from "../../../api/FollowUps";
import { SweetAlertShow } from "../../master/Master";

export const CardDiv = ({ setFilters, filters, type }) => {
  const isActive = filters?.attendance === type?.value;

  return (
    <div className="col-lg-2 col-md-3 col-sm-4 col-6">
      <div
        onClick={() => {
          setFilters({
            ...filters,
            attendance: type?.value,
          });
        }}
        className={`p-2 rounded-3 cursor-pointer border transition-all
            ${isActive
            ? `bg-${type?.color} text-white border-${type?.color} shadow`
            : `bg-${type?.color}-subtle border-transparent`
          }
          `}
        style={{
          cursor: "pointer",
          transition: "0.3s",
        }}
      >
        <h6
          className={`mb-1 ${isActive ? "text-white" : `text-${type?.color}`}`}
        >
          {type?.label}
        </h6>

        <h5 className="fw-bold mb-0">{type?.showValue}</h5>
      </div>
    </div>
  );
};

export const CardDiv2 = ({ setFilters, filters, type, onClick }) => {
  return (
    <div
      className="col-xl-3 col-6"
      data-bs-toggle="modal"
      data-bs-target="#MainModal"
      style={{ cursor: "pointer" }}
      onClick={onClick}
    >
      <div className="card card-transform">
        <div className="card-body">
          <div className="d-flex justify-content-between align-items-center">
            <div>
              <p className="text-muted mb-0">{type?.label}</p>
              <h4 className={`fw-bold mb-0 text-${type?.color}`}>
                {type?.showValue}
              </h4>
            </div>
            <div
              className={`p-2 bg-${type?.color}-subtle text-${type?.color} rounded-3`}
            >
              <i className={`${type?.icon} ri-20px `}></i>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export const CardDiv3 = ({ setFilters, filters, type, onClick, isActive }) => {
  return (
    <div
      className="col"
      style={{
        cursor: "pointer",
        transition: "0.3s",
      }}
      onClick={onClick}
    >
      <div
        className={`p-2 rounded-3 cursor-pointer border transition-all
            ${isActive
            ? `bg-${type?.color} text-white border-${type?.color} shadow`
            : `bg-${type?.color}-subtle border-transparent`
          }
          `}
      >
        <h6
          className={`mb-1 ${isActive ? "text-white" : `text-${type?.color}`}`}
        >
          {type?.label}
        </h6>

        <h5 className="fw-bold mb-0">{type?.showValue}</h5>
      </div>
    </div>
  );
};

export const ProgressBar = ({ type }) => {
  return (
    <div className="mb-2">
      <div className="d-flex justify-content-between mb-1">
        <span>{type?.label}</span>
        <span className={`fw-bold text-${type?.color}`}>{type?.progress}%</span>
      </div>
      <div className="progress">
        <div
          className={`progress-bar bg-${type?.color}`}
          style={{ width: `${type?.progress}%` }}
        />
      </div>
    </div>
  );
};

// export const getStudentAttendanceList = async ({
//   setLoading,
//   filters,
//   setData,
// }) => {
//   setLoading(true);
//   let addUrl = "";
//   Object.keys(filters).forEach((key) => {
//     const value = filters[key];
//     if (value) {
//       addUrl += `&${key}=${encodeURIComponent(value)}`;
//     }
//   });
//   try {
//     const response = await studentAttendanceList(addUrl);
//     if (response.data.status) {
//       setData(response?.data?.data);
//     } else {
//       SweetAlertShow("info", "Warning", response?.data?.message);
//     }
//   } catch (error) {
//     SweetAlertShow(
//       "error",
//       "Error",
//       error?.response?.data?.message ?? error?.response?.message,
//     );
//   } finally {
//     setLoading(false);
//   }
// };

export const getStudentAttendanceList = async ({
  setLoading,
  filters,
  setData,
}) => {

  setLoading(true);

  try {

    const params = new URLSearchParams();

    if (filters?.date) {
      params.append("date", filters.date);
    }

    if (filters?.session_id) {
      params.append("session_id", filters.session_id);
    }

    if (filters?.course_id) {
      params.append("course_id", filters.course_id);
    }

    if (filters?.batch_id) {
      params.append("batch_id", filters.batch_id);
    }

    if (filters?.staff_id) {
      params.append("staff_id", filters.staff_id);
    }

    if (
      filters?.attendance !== undefined &&
      filters?.attendance !== ""
    ) {
      params.append(
        "attendance",
        filters.attendance
      );
    }

    if (
      filters?.message_filter !== undefined &&
      filters?.message_filter !== ""
    ) {
      params.append(
        "message_filter",
        filters.message_filter
      );
    }

    const response =
      await studentAttendanceList(
        params.toString()
      );

    if (response?.data?.status) {

      setData(
        response?.data?.data ?? {}
      );

    } else {

      SweetAlertShow(
        "info",
        "Warning",
        response?.data?.message
      );

    }

  } catch (error) {

    SweetAlertShow(
      "error",
      "Error",
      error?.response?.data?.message ??
      error?.message
    );

  } finally {

    setLoading(false);
  }
};

export const getStaffAttendanceList = async ({
  setLoading,
  filters,
  setData,
}) => {
  setLoading(true);
  let addUrl = "";
  Object.keys(filters).forEach((key) => {
    const value = filters[key];
    if (value) {
      addUrl += `&${key}=${encodeURIComponent(value)}`;
    }
  });
  try {
    const response = await staffAttendanceList(addUrl);
    if (response.data.status) {
      setData(response?.data?.data);
    } else {
      SweetAlertShow("info", "Warning", response?.data?.message);
    }
  } catch (error) {
    SweetAlertShow(
      "error",
      "Error",
      error?.response?.data?.message ?? error?.response?.message,
    );
  } finally {
    setLoading(false);
  }
};

export const getMessageStatusText = (status) => {
  switch (Number(status)) {
    case 1:
      return { text: "Sent", className: "text-success" };
    case 2:
      return { text: "Not Sent", className: "text-danger" };
    case 3:
      return { text: "Processing", className: "text-warning" };
    case 4:
      return { text: "Failed", className: "text-danger" };
    default:
      return { text: "-", className: "text-secondary" };
  }
};

export const getFollowupsList = async ({ setLoading, filters, setData }) => {
  setLoading(true);
  let addUrl = "type=attendance";
  Object.keys(filters).forEach((key) => {
    const value = filters[key];
    if (value) {
      addUrl += `&${key}=${encodeURIComponent(value)}`;
    }
  });
  try {
    const response = await AttendanceFollowupList(addUrl);
    if (response.data.status) {
      const sortedData = [...(response?.data?.data || [])].sort((a, b) => {
        const isPendingA = !(
          a?.attendance_followups?.[0]?.followup_date &&
          a?.attendances?.[0]?.date &&
          new Date(a.attendance_followups[0].followup_date) >=
          new Date(a.attendances[0].date)
        );

        const isPendingB = !(
          b?.attendance_followups?.[0]?.followup_date &&
          b?.attendances?.[0]?.date &&
          new Date(b.attendance_followups[0].followup_date) >=
          new Date(b.attendances[0].date)
        );

        return Number(isPendingB) - Number(isPendingA);
      });

      setData(sortedData);
    } else {
      SweetAlertShow("info", "Warning", response?.data?.message);
    }
  } catch (error) {
    SweetAlertShow(
      "error",
      "Error",
      error?.response?.data?.message ?? error?.response?.message,
    );
  } finally {
    setLoading(false);
  }
};

export const CardDiv4 = ({ type, onClick }) => {
  return (
    <div
      className="col-xl-3 col-6"
      style={{ cursor: "pointer" }}
      onClick={onClick}
    >
      <div className="card card-transform">
        <div className="card-body">
          <div className="d-flex justify-content-between align-items-center">
            <div>
              <p className="text-muted mb-0">{type?.label}</p>
              <h4 className={`fw-bold mb-0 text-${type?.color}`}>
                {type?.showValue}
              </h4>
            </div>

            <div
              className={`p-2 bg-${type?.color}-subtle text-${type?.color} rounded-3`}
            >
              <i className={`${type?.icon} ri-20px`}></i>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
